window.addEventListener("hoContentLoaded", () => {

	/* plays in the audio provider */
	Vue.component('standard-audio', {
		data: () => ({
			src : null,
		}),

		computed: {
			time : function ()
			{
				if(this.$store.getters['audio/data'])
				{
					if(this.$store.getters['audio/data'].src === this.data.src)
					{
						return this.$store.getters['audio/time'];
					}
					else
					{
						return 0;
					}
				}
				else
				{
					return 0;
				}
			},

			playing : function ()
			{
				if(this.$store.getters['audio/data'])
				{
					if(this.$store.getters['audio/data'].src === this.data.src)
					{
						if(this.$store.getters['audio/playing'])
							return true;
					}
					else
					{
						return 0;
					}
				}
				else
				{
					return 0;
				}

				return false;
			}
		},

		methods: {
			play()
			{
				store.dispatch({type: 'audio/play',query: this.data});
			},

			pause()
			{
				if(this.playing)
				{
					store.dispatch({type: 'audio/pause',query: this.data});
				}
			},
		},

		mounted () {
			this.data = JSON.parse(this.$refs.data.innerHTML);
		}
	});

	/* plays only locally */
	Vue.component('standard-audio-local', {
		mixins: [mixinViewport],
		data: () => ({
			data: null,
			src: null,
			percent: 0,
			end: 0,
			visible: false,
			time: 0,
			playing: false,

		}),

		methods: {
			play() {
				this.playing = true;
				this.$refs.audio.play();
			},

			pause() {
				this.playing = false;
				this.$refs.audio.pause();
			},

			dragStart(event) {
				document.addEventListener('mouseup', this.dragEnd, { passive: true });
				document.addEventListener('touchend', this.dragEnd, { passive: true });
				document.addEventListener('touchmove', this.drag, { passive: true });
				document.addEventListener('mousemove', this.drag, { passive: true });
			},

			drag(event) {
				let pageX = 0;

				const bounds = this.viewport(this.$refs.progress);


				if (event.changedTouches) {
					pageX = event.changedTouches[0].pageX;
				}
				else
					pageX = event.pageX;

				this.$refs.audio.currentTime = ((pageX - bounds.l) / bounds.w) * this.$refs.audio.duration;
			},

			dragEnd(event) {
				this.drag(event);
				document.removeEventListener('mousemove', this.drag, { passive: true });
				document.removeEventListener('mouseup', this.dragEnd, { passive: true });
				document.removeEventListener('touchend', this.dragEnd, { passive: true });
				document.removeEventListener('touchmove', this.drag, { passive: true });
			},
		},

		mounted() {
			this.data = JSON.parse(this.$refs.data.innerHTML);

			console.log('refs', this.$refs);


			this.$refs.audioSource.src = this.data.src;
			this.$refs.audio.load();
			this.progress = 0;
			this.start = 0;
			this.percent = 0;
			this.end = 0;
			this.time = 0;

			gsap.to(this.$refs.pointer, .1, { left: this.percent + "%", ease: Linear.easeNone });
			gsap.to(this.$refs.bar, .1, { width: this.percent + "%", ease: Linear.easeNone });
			


			this.progress = this.$refs.progress;

			this.$refs.audio.onloadedmetadata = () => {
				this.start = this.$refs.audio.currentTime;
				this.end = this.$refs.audio.duration;
			};

			console.log('this.$refs.audio', this.$refs.audio);
			this.$refs.audio.ontimeupdate = () => {
				console.log('ontimeupdate');
				this.end = this.$refs.audio.duration;
				this.percent = (this.$refs.audio.currentTime / this.$refs.audio.duration * 100);
				this.time = this.$refs.audio.currentTime;

				gsap.to(this.$refs.pointer,.1,{left:this.percent + "%",ease:Linear.easeNone});
				gsap.to(this.$refs.bar,.1,{width:this.percent + "%",ease:Linear.easeNone});
			};
		}
	});
	
});
